/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OfferProductConfigurationResponse } from '../../models/offer-product-configuration-response';

export interface GetOfferProductConfiguration$Params {
  id: number;
  productId: number;
}

export function getOfferProductConfiguration(http: HttpClient, rootUrl: string, params: GetOfferProductConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<OfferProductConfigurationResponse>> {
  const rb = new RequestBuilder(rootUrl, getOfferProductConfiguration.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('productId', params.productId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OfferProductConfigurationResponse>;
    })
  );
}

getOfferProductConfiguration.PATH = '/offers/{id}/product-articles/{productId}';
